import Layout from '@/pages/Layout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsNew from '@/pages/Administrators/New.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

import Clients from '@/pages/Clients.vue'
import ClientsView from '@/pages/Clients/View.vue'
import ClientsDetail from '@/pages/Clients/Detail.vue'
import ClientsNew from '@/pages/Clients/New.vue'
import ClientsEdit from '@/pages/Clients/Edit.vue'
import ClientsNewChannel from '@/pages/Clients/NewChannel.vue'
import ClientsEditChannel from '@/pages/Clients/EditChannel.vue'

import Log from '@/pages/Log.vue'
import LogView from '@/pages/Log/View.vue'
import LogDetail from '@/pages/Log/Detail.vue'

import Route404 from '@/pages/404.vue'
import Auth from '@/pages/Auth.vue'
import Login from '@/pages/Login.vue'

const routes = [
	{
		path: '/auth/:token',
		component: Auth,
	},
	{
		path: '/login',
		component: Login,
	},
	{
		path: '/',
		redirect: "dashboard",
		component: Layout,
		children: [
			{
				path: 'dashboard',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						component: SettingsView
					},
				]
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						component: AdministratorsView
					},
					{
						path: 'new',
						component: AdministratorsNew
					},
					{
						path: 'edit/:hash',
						component: AdministratorsEdit
					},
					
				]
			},
			{
				path: 'system_clients',
				component: Clients,
				children: [
					{
						path: '',
						component: ClientsView
					},
					{
						path: 'new',
						component: ClientsNew
					},
					{
						path: 'edit/:hash',
						component: ClientsEdit
					},
					{
						path: 'new_channel/:hash',
						component: ClientsNewChannel
					},
					{
						path: 'edit_channel/:hash',
						component: ClientsEditChannel
					},
					{
						path: 'detail/:hash',
						component: ClientsDetail
					},
					
				]
			},
			{
				path: 'system_log',
				component: Log,
				children: [
					{
						path: '',
						component: LogView
					},
					{
						path: 'detail/:hash',
						component: LogDetail
					},
					
				]
			}
		]
	},
	{
		path: '*',
		component: Route404
	},

]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js